module.exports = __webpack_public_path__ + "static/media/blog10_big.db4c8aa0.webp";